import { render, staticRenderFns } from "./is-quiz-answer.vue?vue&type=template&id=5e268394&scoped=true"
import script from "./is-quiz-answer.vue?vue&type=script&lang=js"
export * from "./is-quiz-answer.vue?vue&type=script&lang=js"
import style0 from "./is-quiz-answer.vue?vue&type=style&index=0&id=5e268394&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e268394",
  null
  
)

export default component.exports